import React, { useState } from 'react';
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
} from '@material-ui/core';
import { toJS } from 'mobx';
import { Link } from 'react-router-dom';
import { Observer } from 'mobx-react';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, StandardBox } from '../../styles/styles';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';
import XeroLogo from '../../../assets/xero/XeroLogo';
import DeleteOrg from './DeleteOrg';

const OrgManage = () => {
  const { orgStore, authStore } = useRootStore();
  const { settings, isOwner } = orgStore;
  const { ExtSysName, ExtSysId } = settings;
  const isIntegrated = ExtSysId > 0;

  const getXeroUrl = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/xero-url`,
      );
      window.location = data;
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Observer
      render={() => (
        <FlexDiv>
          <StandardBox>
            <Typography variant="h4" gutterBottom>
              Management
            </Typography>
            <List>
              <ListItem button component={Link} to="/ext-sys-mapper">
                <ListItemText
                  primary="Map Chart of Accounts"
                  secondary="Link accounts between Deal Map and external accounting system"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/transaction-category-mapper"
              >
                <ListItemText
                  primary="Map Transaction Categories"
                  secondary="Link transaction categories between Deal Map and external accounting system"
                />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/organization/agent-contacts"
              >
                <ListItemText
                  primary="Manage Agents"
                  secondary="View and edit commissions for contact agents"
                />
              </ListItem>
              {isIntegrated && (
                <ListItem
                  button
                  component={Link}
                  to="/external-system-settings"
                >
                  <ListItemText
                    primary={`Manage ${ExtSysName} Integration`}
                    secondary="View and edit settings for external system"
                  />
                </ListItem>
              )}
              {!isIntegrated && isOwner && (
                <ConfirmDialog
                  title="Connect to an Accounting System"
                  content={() => {
                    return (
                      <div>
                        <p>
                          Select an accounting system to link this organization
                          to. If you have already added data to your Deal Map
                          organization, it is recommended you create a new
                          organization through the sync process to avoid any
                          potential discrepancies in your data.
                        </p>
                        <List>
                          <ListItem
                            onClick={() => getXeroUrl()}
                            style={{
                              width: 'fit-content',
                              padding: '0',
                              cursor: 'pointer',
                            }}
                          >
                            <XeroLogo />
                          </ListItem>
                        </List>
                      </div>
                    );
                  }}
                  actions={({ handleClose }) => (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        flex: 1,
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="contained"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  )}
                >
                  {({ handleOpen }) => {
                    return (
                      <ListItem button onClick={() => handleOpen()}>
                        <ListItemText
                          primary="Link to an Accounting System"
                          secondary="Link this organization by pulling data from an existing accounting system"
                        />
                      </ListItem>
                    );
                  }}
                </ConfirmDialog>
              )}
              {!!isOwner && <DeleteOrg orgName={settings.Name} />}
            </List>
          </StandardBox>
        </FlexDiv>
      )}
    />
  );
};

export default OrgManage;
